var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.908,
    height: 31.908,
    viewBox: "0 0 31.908 31.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1715",
    "data-name": "Group 1715",
    transform: "translate(-35 -551.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497",
    transform: "translate(35 551.501)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 15.954,
    cy: 15.954,
    r: 15.954,
    fill: "#8c63ee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498",
    transform: "matrix(0.891, -0.454, 0.454, 0.891, -3202.959, 2770.462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M3890.353-487.483a2.92,2.92,0,0,1,.459-1.066,2.278,2.278,0,0,1,1.855-.938c1-.008,1.992,0,2.988,0a.822.822,0,0,0,.3-.058q3.059-1.236,6.114-2.484a.451.451,0,0,0,.216-.212,1.861,1.861,0,0,1,2.019-1.08,1.824,1.824,0,0,1,1.519,1.763c.017.636.006,1.272.006,1.908,0,2.711-.011,5.423.006,8.134a1.9,1.9,0,0,1-1.231,1.861,1.859,1.859,0,0,1-2.249-.862.445.445,0,0,0-.191-.194q-2.725-1.115-5.455-2.217c-.04-.016-.082-.027-.15-.048v.222c0,.912,0,1.825,0,2.737a1.761,1.761,0,0,1-1.443,1.772,1.73,1.73,0,0,1-2.057-1.556c-.045-1.071-.018-2.145-.022-3.218v-.255c-.2-.009-.379-.008-.556-.027a2.314,2.314,0,0,1-2.089-1.929.554.554,0,0,0-.033-.089Zm11.765-3.223c-.076.026-.131.042-.184.063q-2.62,1.062-5.242,2.122c-.122.049-.139.12-.139.233,0,1.259.005,2.518,0,3.777a.241.241,0,0,0,.182.263q2.045.822,4.084,1.653c.427.173.854.343,1.3.523Zm2.474,4.243q0-2.428,0-4.856c0-.077,0-.154,0-.231a.6.6,0,0,0-.574-.566.6.6,0,0,0-.637.518,1.7,1.7,0,0,0-.012.25q0,4.894,0,9.788a1.643,1.643,0,0,0,.016.269.605.605,0,0,0,.728.488.614.614,0,0,0,.483-.67Q3904.594-483.968,3904.592-486.463Zm-9.287,1.93v-3.723c-.876,0-1.736,0-2.6,0a1.082,1.082,0,0,0-1.12,1.117c0,.475,0,.951,0,1.426a1.1,1.1,0,0,0,1.19,1.188q1.166,0,2.332,0C3895.172-484.524,3895.235-484.529,3895.305-484.533Zm.006,1.255h-1.032c0,.054-.013.1-.013.154q0,1.53,0,3.06a1.072,1.072,0,0,0,.014.172.51.51,0,0,0,.509.434.534.534,0,0,0,.532-.6q0-1.53,0-3.06C3895.321-483.166,3895.315-483.216,3895.311-483.278Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M4208.985-319.508a.607.607,0,0,1-.873.55c-.482-.251-.951-.531-1.416-.816a.6.6,0,0,1-.19-.8.6.6,0,0,1,.795-.257c.479.258.949.537,1.418.815A.589.589,0,0,1,4208.985-319.508Z",
    transform: "translate(-299.792 -163.577)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M4221.359-371.289c.256,0,.513-.007.77,0a.61.61,0,0,1,.6.58.6.6,0,0,1-.56.64c-.544.021-1.09.02-1.634,0a.6.6,0,0,1-.567-.637.611.611,0,0,1,.619-.586c.256-.007.513,0,.77,0Z",
    transform: "translate(-312.637 -115.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M4207.114-434.73a.633.633,0,0,1-.634-.42.586.586,0,0,1,.221-.683c.475-.29.957-.571,1.449-.834a.589.589,0,0,1,.768.246.589.589,0,0,1-.165.8c-.472.3-.961.564-1.446.838A.616.616,0,0,1,4207.114-434.73Z",
    transform: "translate(-299.812 -53.712)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/Announcement.faacfb24ca0105ab8241025ff068860a.svg";
export { ForwardRef as ReactComponent };